export const iconCheck={name:"check",data:'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.4 26.6" aria-hidden="true"><path d="m33 4-3-4-19 19-7-7-4 4 11 11 4-4z"/></svg>'};
